class ServerRequestWrapper {
  constructor(baseUri) {
    this.baseUri = baseUri;
  }

  _handleValue = (data, prop) => {
    if (Array.isArray(data[prop])) {
      return data[prop].map((value) => prop + "=" + value).join("&");
    }
    return prop + "=" + data[prop];
  };

  getData = (endpoint, data, headers) => {
    var queryString = Object.keys(data)
      .map((prop) => this._handleValue(data, prop))
      .join("&");
    var url = this.baseUri + endpoint + "?" + queryString;
    return fetch(url, {
      method: "GET",
      credentials: "include",
      headers: new Headers({
        "Content-Type": "application/json",
        ...headers,
      }),
    })
      .catch(this._throwGenericError)
      .then(this._handleResponse);
  };

  get = (endpoint, data, headers) => {
    let queryString = void 0;
    if (data && typeof data === "object") {
      queryString = Object.keys(data)
        .map((prop) => this._handleValue(data, prop))
        .join("&");
    }

    let requestPayload = {
      method: "GET",
      credentials: "include",
      headers: new Headers({
        "Content-Type": "application/json",
        ...headers,
      }),
    };

    let uri;
    if (queryString !== void 0) {
      uri = `${this.baseUri}${endpoint}?${queryString}`;
    } else {
      uri = `${this.baseUri}${endpoint}`;
    }

    return fetch(uri, requestPayload).catch(this._throwGenericError).then(this._handleResponse);
  };

  postData = (endpoint, data, headers) => {
    return fetch(this.baseUri + endpoint, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(data),
      headers: new Headers({
        "Content-Type": "application/json",
        ...headers,
      }),
    })
      .catch(this._throwGenericError)
      .then(this._handleResponse);
  };

  putData = (endpoint, data, headers) => {
    return fetch(this.baseUri + endpoint, {
      method: "PUT",
      credentials: "include",
      body: JSON.stringify(data),
      headers: new Headers({
        "Content-Type": "application/json",
        ...headers,
      }),
    })
      .catch(this._throwGenericError)
      .then(this._handleResponse);
  };

  postDataNoErrorCatch = (endpoint, data, headers) => {
    return fetch(this.baseUri + endpoint, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(data),
      headers: new Headers({
        "Content-Type": "application/json",
        ...headers,
      }),
    });
  };

  patchData = (endpoint, data, headers) => {
    return fetch(this.baseUri + endpoint, {
      method: "PATCH",
      credentials: "include",
      body: JSON.stringify(data),
      headers: new Headers({
        "Content-Type": "application/json",
        ...headers,
      }),
    })
      .catch(this._throwGenericError)
      .then(this._handleResponse);
  };

  _handleResponse = (response) => {
    if (response.ok) {
      return response.text().then((readtext) => {
        if (readtext.length) {
          return JSON.parse(readtext);
        } else {
          return readtext;
        }
      });
    } else {
      return this._handleErrorResponse(response);
    }
  };

  _throwGenericError = () => {
    var error = { message: "Fel vid anslutning till server." };
    throw error;
  };

  _handleErrorResponse = (response) => {
    if (response.json) {
      return response
        .json()
        .catch(this._throwGenericError)
        .then((json) => {
          var toThrow = json;
          try {
            toThrow = JSON.parse(json.message);
          } catch {}
          throw toThrow;
        });
    } else {
      this._throwGenericError();
    }
  };
}
export default ServerRequestWrapper;
